import CarrierAssembly from "@/pages/mill/carriers";
import { CarrierBuildFormPage } from "@/pages/mill/carriers/components/build/CarrierBuildFormPage";
import CobblesManager from "@/pages/mill/cobbles/manager";
import Dashboard from "@/pages/mill/gantt";
import MillOverview from "@/pages/mill/overview";
import RejectedManager from "@/pages/mill/rejected/manager";
import MillOverview2 from "@/pages/mill/overview-2";
import Campaign from "@/pages/mill/schedule";

export const routeCarrierAssembly = "mill/carriers-assembly";
export const routeMillOverview = "/mill/overview";
export const routeMillOverview2 = "/mill/overview-2";
export const routeMillSchedule = "/mill/schedule";
export const routeCobblesManager = "/mill/cobbles/manager";
export const routeRejectedManager = "/mill/rejected/manager";
export const routeMillGantt = "/mill/gantt";

export const millRoutes = [
	{
		path: routeCarrierAssembly,
		element: <CarrierAssembly />,
		permission: "ui.navbar.mill.carrier.status",
	},
	{
		path: `${routeCarrierAssembly}/:partId`,
		element: <CarrierAssembly />,
		permission: "ui.navbar.mill.carrier.status",
	},
	{
		path: `${routeCarrierAssembly}/:carrierId/view/:carrierInstanceId`,
		element: <CarrierBuildFormPage />,
		permission: "ui.navbar.mill.carrier.status",
	},
	{
		path: `${routeCarrierAssembly}/:carrierId/build/:carrierInstanceId`,
		element: <CarrierBuildFormPage />,
		permission: "ui.navbar.mill.carrier.status",
	},
	{
		path: `${routeCarrierAssembly}/:carrierId/sign/:carrierInstanceId`,
		element: <CarrierBuildFormPage />,
		permission: "ui.navbar.mill.carrier.status",
	},
	{
		path: `${routeCarrierAssembly}/:carrierId/build/:carrierInstanceId/answer-all`,
		element: <CarrierBuildFormPage />,
		permission: "ui.navbar.mill.carrier.status",
	},
	{
		path: `${routeMillOverview}`,
		element: <MillOverview />,
		permission: "ui.navbar.mill.overview",
	},
	{
		path: `${routeMillOverview2}`,
		element: <MillOverview2 />,
		permission: "ui.navbar.mill.overview2",
	},
	{
		path: `${routeMillSchedule}`,
		element: <Campaign />,
		permission: "ui.navbar.mill.schedule",
	},
	{
		path: `${routeMillSchedule}/:campaignId`,
		element: <Campaign />,
		permission: "ui.navbar.mill.schedule",
	},
	{
		path: `${routeCobblesManager}`,
		element: <CobblesManager />,
		permission: "ui.navbar.mill.cobbles.manager",
	},
	{
		path: `${routeCobblesManager}/:shiftId`,
		element: <CobblesManager />,
		permission: "ui.navbar.mill.cobbles.manager",
	},
	{
		path: `${routeRejectedManager}`,
		element: <RejectedManager />,
		permission: "ui.navbar.mill.rejected.manager",
	},
	{
		path: `${routeRejectedManager}/:shiftId`,
		element: <RejectedManager />,
		permission: "ui.navbar.mill.rejected.manager",
	},
	{
		path: `${routeMillGantt}`,
		element: <Dashboard />,
		permission: "ui.navbar.mill.gantt",
	},
	{
		path: `${routeMillGantt}/:shiftId`,
		element: <Dashboard />,
		permission: "ui.navbar.mill.gantt",
	},
];
